import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
})
export default class Offset extends Vue {

  @Prop({type: Boolean, default: false})
  fullWidth: boolean;

  @Prop({type: [Number, String], default: 24})
  offset: any;


  // computed
  public get classes() {
    return { 'v-offset--full-width': this.fullWidth };
  }

  public get styles() {
    return {
      top: `-${this.offset}px`,
      marginBottom: `-${this.offset}px`
    };
  }

}
